module.exports = __webpack_public_path__ + "logostokes1-8yx.jpg";